import { render, staticRenderFns } from "./cardView.vue?vue&type=template&id=3192a9f1"
import script from "./cardView.vue?vue&type=script&lang=js"
export * from "./cardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports